import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useQueryParams } from "../../../lib/useQueryParams";
import { addQueryLocalStorage } from "../../../lib/utils";

const Gender = (props) => {

  const [gender, setGender] = useState("all");

  const handleSelectGender = (value) => {
    setGender(value);
    console.log(value);
    addQueryLocalStorage("gender_info",value);
  }
  const location = useLocation();
  const {getAllQueryParams} = useQueryParams();

  useEffect(()=>{
    const q = getAllQueryParams();
    if(!q?.gender_info) setGender("all");
    else setGender(q.gender_info);
  },[location.search]);

  useEffect(()=>{
    if(props.isReset){
      setGender("all");
      if(props.handleResetState) props.handleResetState();
    }
  },[props.isReset]);

  useEffect(() => {
    if (props.isReset) {
      setGender("all");
    }
  }, [props.isReset]);

  return(
    <div className="w-full">
      <p className="fs-16 font-weight-700 color-black m-b-8">Gender</p>
      <div className='d-flex'>
        <div onClick={()=>handleSelectGender("all")} className="d-flex flex-item m-r-20">
          <input className="flex-item m-r-8" type="radio" name="gender" checked={gender == "all"} style={{width:"20px", height:"20px"}}/>
          <p className="flex-item fs-16 font-weight-600">All</p>
        </div>
        <div onClick={()=>handleSelectGender("Male")} className="d-flex flex-item m-r-20">
          <input className="flex-item m-r-8" type="radio" name="gender" checked={gender == "Male"} style={{width:"20px", height:"20px"}}/>
          <p className="flex-item fs-16 font-weight-600">Male</p>
        </div>
        <div onClick={()=>handleSelectGender("Female")} className="d-flex flex-item">
          <input className="flex-item m-r-8" type="radio" name="gender" checked={gender == "Female"} style={{width:"20px", height:"20px"}}/>
          <p className="flex-item fs-16 font-weight-600" >Female</p>
        </div>
      </div>
    </div>
  )
}

export default Gender